/**
 * URL utility functions for handling logo URLs and static assets
 */

/**
 * Get the backend base URL (without /api/v1 suffix)
 */
const getBackendBaseUrl = (): string => {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
  // Remove /api/v1 suffix to get base URL
  return API_URL.replace(/\/api\/v1\/?$/, '');
};

/**
 * Resolve a logo URL to a full URL if it's a relative static path
 * @param logoUrl The logo URL (can be full URL, relative path, or data URL)
 * @returns Resolved URL ready for use in img src
 */
export const resolveLogoUrl = (logoUrl: string | null | undefined): string => {
  if (!logoUrl) {
    return '';
  }

  // If it's already a full URL (http/https) or data URL, return as is
  if (logoUrl.startsWith('http://') || logoUrl.startsWith('https://') || logoUrl.startsWith('data:')) {
    return logoUrl;
  }

  // If it's a relative static path, prepend backend base URL
  if (logoUrl.startsWith('/static/')) {
    const baseUrl = getBackendBaseUrl();
    return `${baseUrl}${logoUrl}`;
  }

  // For other relative paths or URLs, return as is
  return logoUrl;
};

/**
 * Check if a URL is a base64 data URL
 */
export const isDataUrl = (url: string | null | undefined): boolean => {
  return Boolean(url && url.startsWith('data:'));
};

/**
 * Check if a URL is a static file path
 */
export const isStaticPath = (url: string | null | undefined): boolean => {
  return Boolean(url && url.startsWith('/static/'));
};



